import { setVonageMetadata, isSupported as checkApiSupport } from '@vonage/media-processor';
import { createVonageMediaProcessor } from '@vonage/ml-transformers';
import createLogger from '../../helpers/log';
import env from '../../helpers/env';

const createML = ({
  setMetadata = setVonageMetadata,
  createProcessor = createVonageMediaProcessor,
  checkSupport = checkApiSupport,
  deprecationLogging = createLogger('deprecation'),
} = {}) => {
  const isSupported = (mediaType = 'both') => {
    deprecationLogging.warn('OT.hasMediaProcessorSupport is deprecated, and will be removed in the future. Use OT.hasMediaProcessorSupport.promise instead');
    if ((mediaType === 'audio' || mediaType === 'both') && (env.isSafari || env.isFirefox)) return false;
    if (env.isSafari) {
      // Video filters only available on safari/webview > 26, but cannot check the version because it's obfuscated in webview
      if (!window.OffscreenCanvas) return false;
      const oc = new window.OffscreenCanvas(0, 0);
      try {
        const ctx = oc.getContext('webgpu');
        return ![null, undefined].includes(ctx);
      } catch (_) {
        return false;
      }
    }
    const hasNativeSupport = (typeof MediaStreamTrackProcessor !== 'undefined'
      && typeof MediaStreamTrackGenerator !== 'undefined');
    const canPolyfill = [
      window.ReadableStream, window.WritableStream,
      window.MediaStream, window.OffscreenCanvas, window.VideoFrame,
      window.AudioContext, window.AudioWorkletNode,
    ].every(prop => prop !== undefined);
    return hasNativeSupport || canPolyfill;
  };

  isSupported.promise = async (mediaType = 'both') => {
    if ((mediaType === 'audio' || mediaType === 'both') && (env.isSafari || env.isFirefox)) return false;
    try {
      await checkSupport();
      return true;
    } catch (_) {
      return false;
    }
  };

  return {
    isSupported,
    setMetadata,
    createProcessor,
  };
};

// Vonage's low-level machine-learning-based media processor libraries
const ML = createML();

export { createML };
export default ML;
